// extracted by mini-css-extract-plugin
export default {"container":"WordGameLayout_container__bta74","sub_container":"WordGameLayout_sub_container__i7j8E"};